import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "btn btn-success",
  href: "ordering/create"
}
const _hoisted_2 = {
  class: "d-flex justify-content-end",
  style: {"gap":"10px"}
}
const _hoisted_3 = {
  class: "d-none d-md-inline-block ms-1",
  title: "inaktiv := abgeschlossen, abgelehnt, nicht eingetroffen oder fehlerhaft (nach 7 Tagen)"
}
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header text-white bg-secondary" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "table-container" }
const _hoisted_11 = { class: "text-center my-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_13 = {
  key: 1,
  class: "text-center"
}
const _hoisted_14 = { class: "text-danger my-1" }
const _hoisted_15 = {
  key: 0,
  class: "multiselect__single"
}
const _hoisted_16 = {
  key: 1,
  class: "multiselect__single"
}
const _hoisted_17 = {
  key: 2,
  class: "multiselect__single"
}
const _hoisted_18 = { key: 3 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "option__desc" }
const _hoisted_21 = { class: "option__title" }
const _hoisted_22 = { class: "option__small ms-1" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")
  const _component_b_row = _resolveComponent("b-row")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_popover = _resolveComponent("b-popover")
  const _component_b_table = _resolveComponent("b-table")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_row, {
      class: "mt-3 mb-4",
      style: {"white-space":"nowrap"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            ($props.hasCreatePermission)
              ? (_openBlock(), _createElementBlock("a", _hoisted_1, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1 /* CACHED */),
                  _createTextVNode("Bestellanfrage anlegen ", -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_b_button, {
                onClick: _cache[0] || (_cache[0] = $event => ($options.fetchOrderings(!$data.inactiveShown)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass($data.inactiveShown ? 'fas fa-eye-slash' : 'fas fa-eye')
                  }, null, 2 /* CLASS */),
                  _createElementVNode("span", _hoisted_3, _toDisplayString($data.inactiveShown ? 'inaktive verbergen' : 'inaktive anzeigen'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_form_checkbox, {
                switch: "",
                "wrapper-attrs": {style: 'position: relative; top: 6px;'},
                onChange: $options.toggleAdvancedView
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" erweiterte Ansicht ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onChange"])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_row, { style: {"white-space":"nowrap","width":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, null, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"font-size":"x-large"} }, " Bestellanfragen ", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                  _cache[11] || (_cache[11] = _createTextVNode("Summe: ", -1 /* CACHED */)),
                  _createElementVNode("b", null, _toDisplayString($options.formatCosts($options.invoiceSum)), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_col, { style: {"display":"inline-flex","gap":"10px","justify-content":"end","align-items":"center"} }, {
              default: _withCtx(() => [
                _createVNode(_component_b_button, {
                  title: "Bestellanfragen herunterladen",
                  class: "btn-sm",
                  onClick: $options.downloadOrderings
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fas fa-download" }, null, -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createVNode(_component_v_multiselect, {
                  modelValue: $data.yearFilter,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.yearFilter) = $event)),
                  style: {"width":"194px"},
                  options: $options.invoiceYears,
                  multiple: true,
                  "close-on-select": false,
                  "select-label": "Eintrag auswählen",
                  "selected-label": "ausgewählt",
                  "deselect-label": "Auswahl aufheben",
                  placeholder: "nach Jahr(en) filtern",
                  "open-direction": "bottom"
                }, {
                  selection: _withCtx(({ values, isOpen }) => [
                    (values.length === 1 && !isOpen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(values[0]), 1 /* TEXT */))
                      : (values.length > 1 && !isOpen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(values.length) + " Jahre ausgewählt", 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8))
                  ]),
                  beforeList: _withCtx(() => [
                    _createElementVNode("li", {
                      class: "multiselect__option",
                      onClick: _cache[1] || (_cache[1] = $event => ($data.yearFilter = []))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                      _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                    ]))])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_b_table, {
            id: "ordering-index-table",
            ref: "table",
            busy: $data.isBusy,
            "onUpdate:busy": _cache[8] || (_cache[8] = $event => (($data.isBusy) = $event)),
            class: "bootstrap-vue-table-borders",
            striped: "",
            hover: "",
            "sticky-header": "100%",
            "show-empty": "",
            "primary-key": "id",
            fields: $options.visibleFields,
            items: $options.filteredOrderings,
            "sort-by": [{key: 'status', order: 'asc'}],
            "tbody-tr-class": (item) => (item?.status < 0) ? 'row-danger' : ''
          }, {
            "table-busy": _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_b_spinner, {
                  small: "",
                  type: "grow",
                  variant: "secondary"
                }),
                _createVNode(_component_b_spinner, {
                  style: {"animation-delay":"0.1s"},
                  small: "",
                  type: "grow",
                  variant: "secondary"
                }),
                _createVNode(_component_b_spinner, {
                  style: {"animation-delay":"0.2s"},
                  small: "",
                  type: "grow",
                  variant: "secondary"
                })
              ])
            ]),
            empty: _withCtx(() => [
              (!$data.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Keine passenden Ergebnisse gefunden. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.error.message) + "). ", 1 /* TEXT */),
                    _createVNode(_component_b_button, {
                      onClick: _cache[3] || (_cache[3] = $event => ($options.fetchOrderings(!$data.inactiveShown)))
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                        _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]))
            ]),
            "head()": _withCtx(({ field }) => [
              _createElementVNode("div", null, _toDisplayString(field.label), 1 /* TEXT */),
              _createElementVNode("div", null, [
                (field.filter && (field.filter.type === 'string-contains'
                    || field.filter.type === 'decimal-number-contains'))
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 0,
                      modelValue: field.filter.value,
                      "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Suchen...",
                      debounce: "200",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                (field.filter && field.filter.type === 'string-equals')
                  ? (_openBlock(), _createBlock(_component_b_form_input, {
                      key: 1,
                      modelValue: field.filter.value,
                      "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                      type: "text",
                      size: "sm",
                      placeholder: "Gleich...",
                      debounce: "200",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("v-if", true),
                (field.filter && field.filter.type === 'multiselect')
                  ? (_openBlock(), _createBlock(_component_v_multiselect, {
                      key: 2,
                      modelValue: field.filter.value,
                      "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                      options: field.filter.options || [],
                      multiple: true,
                      "track-by": "id",
                      label: "name",
                      "close-on-select": false,
                      "show-pointer": false,
                      "selected-label": "✓",
                      "open-direction": "bottom",
                      placeholder: "Filtern...",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, _createSlots({
                      selection: _withCtx(({ values, isOpen }) => [
                        ($options.isFilteredByActive && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " aktive "))
                          : (values.length > 1 && !isOpen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(values.length) + " Werte ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        (values.length === 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(values[0].short || values[0].name), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18))
                      ]),
                      beforeList: _withCtx(() => [
                        _createElementVNode("li", {
                          class: "multiselect__option",
                          onClick: $event => (field.filter.value = [])
                        }, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                          _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_19),
                        (field.key === 'status')
                          ? (_openBlock(), _createElementBlock("li", {
                              key: 0,
                              class: _normalizeClass(["multiselect__option", {'multiselect__option--selected' : $options.isFilteredByActive}]),
                              onClick: _cache[6] || (_cache[6] = (...args) => ($options.filterByActive && $options.filterByActive(...args)))
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "fa-solid fa-hammer" }, null, -1 /* CACHED */),
                              _createTextVNode(" zeige aktive ", -1 /* CACHED */)
                            ]))], 2 /* CLASS */))
                          : _createCommentVNode("v-if", true),
                        _cache[18] || (_cache[18] = _createElementVNode("li", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                      ]),
                      noResult: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, [
                      (field.key === 'status')
                        ? {
                            name: "option",
                            fn: _withCtx((props) => [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(props.option.name), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_22, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(props.option.icon)
                                  }, null, 2 /* CLASS */)
                                ])
                              ])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            "cell(actions)": _withCtx(({ item }) => [
              _createVNode(_component_b_dropdown, {
                text: "Aktion wählen",
                size: "sm",
                lazy: "lazy"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_dropdown_item, {
                    href: 'ordering/'+item.id+'/view'
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "fas fa-eye" }, null, -1 /* CACHED */),
                      _createTextVNode(" Einsehen ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["href"]),
                  (item.permissions.includes('edit'))
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 0,
                        href: 'ordering/'+item.id+'/edit'
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */),
                          _createTextVNode(" Bearbeiten ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["href"]))
                    : _createCommentVNode("v-if", true),
                  (item.permissions.includes('delete'))
                    ? (_openBlock(), _createBlock(_component_b_dropdown_divider, { key: 1 }))
                    : _createCommentVNode("v-if", true),
                  (item.permissions.includes('delete'))
                    ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: 2,
                        "data-href": 'ordering/'+item.id+'/delete',
                        class: "dropdown-item-danger",
                        variant: "white",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#confirm-delete"
                      }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* CACHED */),
                          _createTextVNode(" Löschen ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["data-href"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            "cell(vendor)": _withCtx(({item, value}) => [
              _createElementVNode("a", {
                href: 'ordering/'+item.id+'/view'
              }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_23)
            ]),
            "cell(departments)": _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value.join(', ')), 1 /* TEXT */)
            ]),
            "cell(employeeName)": _withCtx(({ item, value }) => [
              (item['emailWWU'])
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 'mailto:' + item['emailWWU']
                  }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_24))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(value), 1 /* TEXT */))
            ]),
            "cell(comment)": _withCtx(({ value, index }) => [
              value
                ? (_openBlock(), _createBlock(_component_b_button, {
                    key: 0,
                    id: 'note-btn-' + index,
                    title: "letzter Kommentar"
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode(" anzeigen ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["id"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_b_popover, {
                target: 'note-btn-' + index,
                placement: "top",
                click: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["busy", "fields", "items", "tbody-tr-class"])
        ])
      ])
    ])
  ]))
}